export enum UniteFoSort {
  'TYPE' = 'TYPE',
  'CODE' = 'CODE',
  'ABREVIATION' = 'ABREVIATION',
  'CODE_POSTAL' = 'CODE_POSTAL',
  'VILLE' = 'VILLE',
  'CODE_INSEE' = 'CODE_INSEE',
}
